import {
  UserEditRequest,
  UserActions,
  RoleRequest,
  Role,
  User,
} from "../domain/user";
import { editUserService } from "../infrastructure/services/editUserService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const editUser = {
  async execute(
    name: string,
    username: string,
    role: string,
    emplid: string,
    base_price: string,
    password: string,
    email: string,
    rol: Role
  ): Promise<User> {
    const request: UserEditRequest = await UserActions().editUserRequest(
      name,
      username,
      role,
      emplid,
      base_price,
      password,
      email
    );
    await editUserService.execute(await tokenValidation.execute(), request);
    return UserActions().createUser(
      request.name,
      request.username,
      rol,
      request.emplid,
      request.base_price,
      null,
      request.email
    );
  },
};
